import script from "./StepperHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepperHeader.vue?vue&type=script&setup=true&lang=ts"

import "./StepperHeader.vue?vue&type=style&index=0&id=30625510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30625510"]])

export default __exports__